import moment from "moment/moment";
import WatsonApi from "../../backends/WatsonApi";

interface SchoolFeedItemListQuery {
    organization_id?: string;
    organization__path__descendant_or_eq?: string;
    exclude_sibling_descendants_of_path?: string;
    is_event: boolean;
    created_at__gte: string;
    created_at__lte: string;
    page_size: number;
    ordering: string;
    expand: string[];
    published?: boolean;
}

export const currentRangeUrlQueryFormat = "YYYY-MM-DD";

export const getEventsForRange = async (pathQueryParams, urlQuery, start?: string, end?: string): Promise<EventContentItem[]> => {
    let gte;
    let lte;

    if (start && end) {
        gte = start;
        lte = end;
    }
    else {
        gte = moment().startOf('month').format(currentRangeUrlQueryFormat)
        lte = moment().add(1, 'months').startOf('month').format(currentRangeUrlQueryFormat)
    }

    return new Promise((res, rej) => {
        WatsonApi().then(client => {
            const q: SchoolFeedItemListQuery = {
                'is_event': true,
                'created_at__gte': gte,
                'created_at__lte': lte,
                'page_size': 200,
                'ordering': 'created_at',
                'expand': ['organization'],
                ...pathQueryParams,
            }

            let method;
            if (urlQuery.orgId) {
                method = client.apis.organizations.organizations_schoolfeed_items_list;
            } else {
                method = client.apis.schoolfeed_items.schoolfeed_items_list;
            }

            method({
                organization_pk: urlQuery.orgId,
                ...q,
            }).then(result => {
                res(JSON.parse(result.data).data)
            })
        })
    })
};